import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { CostType } from './costTypes.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/lotTypes');

export const getCostTypes = actionCreator.async<{}, CostType[]>('GET_COST_TYPES');
export const createCostType = actionCreator.async<{ formName: FormName }, CostType>('CREATE_COST_TYPE');
export const updateCostType = actionCreator.async<{ id: string; formName: FormName }, CostType>('UPDATE_COST_TYPE');
export const deleteCostType = actionCreator.async<{ id: string; formName: FormName }, string>('DELETE_COST_TYPE');
